const React = require("react");

const {object, string} = require('yup');

const {openPopupWindow} = require("../../../../../../../emitters/popup");

const {FormWrapper, FormFooter} = require("../../../../../../dumb/FormHandlers");
const {MerchantInputsCode} = require("../../../../../../dumb/FormInputs");

const Popup = require("../../../../../../dumb/Popup/B");
const Field = require("../../../../../../dumb/Field/E");
const FieldId = require("../../../../../../dumb/Field/IdA");
const {apiAuthTfaBind, apiAuthTfaQR, apiAuthTfaConfirm} = require("../../../../../../../api/_auth");
const {accountUpdate} = require("../../../../../../../emitters/account");

module.exports = () => (
  openPopupWindow((setState, self, onMount) => {
    const close = self.close;
    const schema = object({code: string().length(6).required()});
    const resultModalData = [
      '2FA enabled',
      `You\'ve completed 2FA linking to this account.`
    ];

    self.state = {
      ...self.state,
      loading: true
    }

    onMount(() => {
      apiAuthTfaBind()
          .then((bindData = {}) => {
            apiAuthTfaQR().then((res) => {
              return res.blob();
            }).then((blob) => {
              setState({
                loading: false,
                qrcodeUrl: URL.createObjectURL(blob),
                secret: bindData.secret,
              });
            });
          });
    });

    const onSubmit = (params) => (
      apiAuthTfaConfirm(params).then(accountUpdate)
    )

    return (state) => {

      const qrcodeUrl = state.qrcodeUrl;
      const secret = state.secret;

      return (
        <Popup
          caption="Set 2FA Code"
        >
          <FormWrapper
            schema={schema}
            onSubmit={onSubmit}
            resultModalData={resultModalData}
            onResult={close}
          >
            {(formCtx) => (
              <>
                <div className="layoutRow fxwWrap mt20 mh-28 (ph28|w1/2|w@m2)>1">
                  <div>
                    <div className="w260 h260 mhA">
                      {qrcodeUrl ? (
                        <img
                          className="wmax hmax"
                          src={qrcodeUrl}
                          data-testid="qrNew2FA"
                        />
                      ) : null}
                    </div>
                    <div className="mt20 tc">
                      Scan the QR code through the Google Authenticator app
                    </div>
                  </div>
                  <div>
                    <Field label="2FA setup key">
                      <FieldId
                        className="tc"
                        value={secret}
                        data-testid="stringNew2FACode"
                      />
                    </Field>
                    <div className="mt50">
                      <MerchantInputsCode
                        label="Enter the 6 digit authentication code"
                        name="code"
                        formCtx={formCtx}
                        codeLength={6}
                        testId="fieldNew2FACode"
                      />
                    </div>
                  </div>
                </div>
                <FormFooter
                  submitBtnData={{
                    text: 'Set 2FA Code',
                    formCtx,
                    testId: 'submitNew2FACode'
                  }}
                  additionalBtnsList={[
                    {
                      text: 'Cancel',
                      onClick: close,
                      testId: 'cancelNew2FACode'
                    },
                  ]}
                />
              </>
            )}
          </FormWrapper>
        </Popup>
      )
    }

  })
)
